import Vue from 'vue';

Vue.filter('formatAmount', amount => {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '’');
});

Vue.filter('percentage', amount => {
    return (amount && `${amount.toString().replace('.', ',')}%`) || '0%';
});

Vue.filter('validEmail', email => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return email.length <= 200 && re.test(email);
});
